import { Injectable } from '@angular/core';
import { BaseService, CentrifugoService, GameBaseApi, GameLogBase, GameUser } from '@mtgame/core';
import { Observable, Subscription } from 'rxjs';
import { GameRootService } from '@core/services/game-root.service';

export const STORE_USERS_KEY = 'users';
export const STORE_LOGS_KEY = 'logs';

@Injectable()
export abstract class GameTimelineService extends BaseService {
  protected gameId: number;
  private subscription: Subscription;

  get users$(): Observable<GameUser[]> {
    return this.store.get(STORE_USERS_KEY);
  }

  abstract logs$: Observable<GameLogBase[]>;

  protected constructor(
    protected gameRootService: GameRootService,
    protected centrifugoService: CentrifugoService,
    protected gameBaseApi: GameBaseApi,
  ) {
    super();
  }

  async initialize(): Promise<any> {
    const game = this.gameRootService.getGameModel();
    this.gameId = game.id;
    this.listenEvents();

    return Promise.all([
      this.getUsers(),
      this.getLogs()
    ]);
  }

  dispose(): void {
    super.dispose();
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  async getUsers(): Promise<GameUser[]> {
    const users = await this.gameBaseApi.getUsers(this.gameId);
    this.store.save(STORE_USERS_KEY, users);
    return users;
  }

  abstract getLogs(): Promise<GameLogBase[]>;
  protected abstract onGameLogAdded(data: any): void;
  protected abstract onGameLogUpdated(data: any): void;

  private listenEvents(): void {
    const channel = `game_${this.gameId}`;
    this.subscription = this.centrifugoService
      .listen(channel)
      .subscribe(message => {
        switch (message.action) {
          case 'GAME_USER_ADDED': {
            return this.store.appendItem(STORE_USERS_KEY, GameUser.toFront(message.data));
          }

          case 'GAME_LOG_ADDED': {
            return this.onGameLogAdded(message.data);
          }

          case 'GAME_LOG_UPDATED': {
            return this.onGameLogUpdated(message.data);
          }

          case 'GAME_LOG_DELETED': {
            return this.store.deleteItem(STORE_LOGS_KEY, (item: GameLogBase) => item.id === message.data.id);
          }
        }
      });
  }
}
